import React from 'react';
import { ValidationMessage } from '../ValidationMessage';


export const renderErrorMessage = (message: string) => {
    return <ValidationMessage error={message} />
}